import type { EventTicketUrlKind } from '@pulsify/shared/dto'

const FORM_HOSTS = [
  'forms.gle',
  'docs.google.com/forms',
  'forms.office.com',
  'forms.microsoft.com',
  'typeform.com',
  'tally.so',
  'jotform.',
  'surveymonkey.',
  'cognitoforms.com',
  'formstack.com',
  'wufoo.com',
  'eveeno.com',
  'doodle.com',
  'forms.app',
  'forms.zohopublic.',
]

const SIGNUP_WORDS = /anmeld|registr|sign-?up|rsvp|formular|umfrage|(^|[^a-z])forms?([^a-z]|$)/
const TICKET_WORDS = /ticket|eventbrite|eventim|reservix|pretix|tixforgigs|dice\.fm|kaufen/

/** Whether a link most likely signs people up or sells tickets; unclear links sell tickets. */
export function guessTicketUrlKind(url: string, signupRequired = false): EventTicketUrlKind {
  const link = url.trim().toLowerCase()
  if (!link) return 'tickets'
  if (FORM_HOSTS.some((host) => link.includes(host))) return 'registration'
  if (SIGNUP_WORDS.test(link)) return 'registration'
  if (TICKET_WORDS.test(link)) return 'tickets'
  return signupRequired ? 'registration' : 'tickets'
}
